import GlassType from './glass-type'
import { InformationCodes } from './enums'

export interface IGlass {
  id: string
  actionPercentage?: number
  actionTitle?: string
  actionSubTitle?: string
  available?: boolean
  icon?: string
  informationCode?: InformationCodes | string
  isMulti?: boolean
  isSingle?: boolean
  glassTypes?: GlassType[]
  name: string
  readingGlasses?: boolean
  screenGlasses?: boolean
  selected?: boolean
  sportGlasses?: boolean
  subTitle?: string
  sunglasses?: boolean
  usps?: string[]
}

export default class Glass {
  public id: string
  public actionPercentage: number = 0
  public actionTitle: string = ''
  public actionSubTitle: string = ''
  public available: boolean = true
  public description: string = ''
  public icon: string = 'glasstype-single'
  public informationCode: InformationCodes | string = ''
  public isMulti: boolean = false
  public isSingle: boolean = false
  public glassTypes: GlassType[] = []
  public name: string
  public readingGlasses: boolean = false
  public screenGlasses: boolean = false
  public selected: boolean = false
  public sportGlasses: boolean = false
  public subTitle: string = ''
  public sunglasses: boolean = false
  public usps: string[] = []
  // id: "d75236d0-fe33-4fd0-88e6-69271ea044f7",
  // naam: "Enkelvoudige bril",
  // opticien_id: "47854866-d140-43fb-8408-ab77be5ec41a",
  // usp1: "Scherp zicht tot aan de rand",
  // usp2: "Beeldscherpte",
  // usp3: "Cosmetisch",
  // usp4: "Service & Garantie",
  // usp5: "Individueel",
  // usp6: "",
  // usp7: "",
  // actie_titel: "",
  // actie_subtitel: "",
  // actie_percentage: null,
  // sun: null,
  // actie_kleur: null,
  // banner: null

  constructor (glassData: IGlass) {
    const { id, name } = glassData
    this.id = id
    this.name = name
    Object.assign(this, { ...glassData })
  }
}
